import React, {useEffect,useRef} from 'react'

import { useLocation } from 'react-router-dom'
interface MFLoaderPayloadProps {
  containerId: string
  microAppName: string
  manifestDomain: string
  additionalParams?: any
}

declare global {
  interface Window {
    dcSpaMicroFrontendLoader?: {
      init: (apps: any[]) => void
    }
  }
}

interface MfRouteComponentLoaderProps {
  containerId: string
  microAppName: string
  manifestDomain: string
  additionalParams?: any
}

const MfRouteComponentLoader: React.FC<MfRouteComponentLoaderProps> = props => {
  const {
    containerId,
    microAppName,
    manifestDomain,
    additionalParams
  } = props
  const location = useLocation()
  const isFirstRender = useRef(true)  // ← add this


  
  const baseMFLoaderData : MFLoaderPayloadProps = {
    containerId,
    microAppName,
    manifestDomain,
    ...additionalParams
  }

  useEffect(() => {
    if (window.dcSpaMicroFrontendLoader) {
      window.dcSpaMicroFrontendLoader.init([
        baseMFLoaderData
      ])
    } else {
      console.error("dcSpaMicroFrontendLoader is undefined")
    }
  }, [
    containerId,
    // location,
    microAppName,
    manifestDomain,
    additionalParams
  ])


  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    window.dispatchEvent(new PopStateEvent('popstate', { state: null }))
  }, [location.pathname, location.search])


  useEffect(() => {

    return () => {
      if (window[microAppName]?.unmount) {
        console.info(`[MFE Loader] Unmounting ${microAppName} on route leave`)
        try {
          window[microAppName].unmount(containerId)
        } catch (e) {
          console.error(`[MFE Loader] Error during cleanup unmount:`, e)
        }
      }
    }
  }, []) 

  return <div id={containerId}></div>
}

export { MfRouteComponentLoader }